module.exports = __webpack_public_path__ + "static/media/battlefield.ce164c88.jpg";